import { render, staticRenderFns } from "./Mail.Detail.vue?vue&type=template&id=31282272&"
import script from "./Mail.Detail.vue?vue&type=script&lang=js&"
export * from "./Mail.Detail.vue?vue&type=script&lang=js&"
import style0 from "./Mail.Detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports